module.exports = __webpack_public_path__ + "static/media/credit-card.1bee9a80.svg";